module.exports = __webpack_public_path__ + "img/qingyang1.a3e744cf.png";